var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconNoAvatar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M36.9998 6.16699C28.9215 6.16699 22.354 12.7345 22.354 20.8128C22.354 28.737 28.5515 35.1503 36.6298 35.4278C36.8765 35.397 37.1232 35.397 37.3082 35.4278C37.3698 35.4278 37.4007 35.4278 37.4623 35.4278C37.4932 35.4278 37.4932 35.4278 37.524 35.4278C45.4173 35.1503 51.6148 28.737 51.6457 20.8128C51.6457 12.7345 45.0782 6.16699 36.9998 6.16699Z",
    fill: "#7A7A7A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6635 43.6294C44.061 37.8944 30.0318 37.8944 21.3676 43.6294C17.4518 46.2502 15.2935 49.796 15.2935 53.5885C15.2935 57.381 17.4518 60.896 21.3368 63.486C25.6535 66.3844 31.3268 67.8335 37.0001 67.8335C42.6735 67.8335 48.3468 66.3844 52.6635 63.486C56.5485 60.8652 58.7068 57.3502 58.7068 53.5269C58.676 49.7344 56.5485 46.2194 52.6635 43.6294Z",
    fill: "#7A7A7A"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconNoAvatar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-no-avatar.60c5b43ef9017bf2390bf6b6692013aa.svg";